/* Material-ui styles override */
const root = {
    '& .MuiStepLabel-root': {
        alignItems: 'flex-start',
    },
    '& .MuiStepLabel-alternativeLabel': {
        marginTop: '0px',
    },
    '& .MuiStepIcon-completed': {
        color: 'var(--fashionPink)',
    },
    '& .MuiStepIcon-active': {
        color: 'var(--fashionPink)',
    },
    '& .MuiStepConnector-active > .MuiStepConnector-line': {
        border: '1px solid var(--fashionPink)',
    },
    '& .MuiStepConnector-completed > .MuiStepConnector-lineHorizontal': {
        border: '1px solid var(--fashionPink)',
    },
    '& .MuiDialog-paperWidthSm': {
        maxWidth: '1000px',
        width: '55%',
        minHeight: '600px',
    },
    '& .MuiStepper-root': {
        padding: '0px',
    },
    '& .MuiDialogActions-root': {
        borderTop: '1px solid var(--dividerGray)',
        padding: '15px',
    },
    '& .MuiDialogContent-root, .MuiDialogTitle-root': {
        padding: '15px',
    },
    '& .MuiStepConnector-alternativeLabel': {
        top: '12px',
        left: 'calc(-100% + 24px)',
        right: 'calc(100% + 0px)',
        position: 'absolute',
    },
    '& .MuiStepLabel-label.MuiStepLabel-alternativeLabel': {
        textAlign: 'left',
    },
    '& .MuiStep-horizontal': {
        paddingLeft: '0px',
        paddingRight: '0px',
    },
};
export default root;
